import React, {useState} from 'react';
import {Grid} from '@mui/material';
import InspectionCallLogs from '../../ipermitJobPages/recordViews/inspection/callLogsPanel';
import InspectionAiCallLogs from '../../ipermitJobPages/recordViews/inspection/inspectionAiCallLogsPanel';
import CallsIcon from '../../../../static/images/callLogIcon.svg';
import InspectionTestResults from '../../ipermitJobPages/recordViews/inspection/testResultsPanel';
import ResultsIcon from '../../../../static/images/testResults.svg';
import {DrawerWrapper} from '../../../../pieces/drawer';

const  Inspections = ()=> {
  const [aiCallLogsFetchKey, setAiCallLogsFetchKey] = useState(0);

  const tabs =  {
    calls: {
      name: 'Call Logs',
      panel: <InspectionCallLogs isContractor={true}/>,
      icon: CallsIcon
    },
    aiCallLogs: {
      name: 'AI Call Logs',
      onActivate: () => setAiCallLogsFetchKey((k) => k + 1),
      panel: <InspectionAiCallLogs isContractor={true} fetchKey={aiCallLogsFetchKey} />,
      icon: CallsIcon
    },
    tests:{
      name: 'Test results',
      panel: <InspectionTestResults isContractor={true}/>,
      icon: ResultsIcon
    }
  };

  return (
    <Grid container>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <DrawerWrapper tabs={tabs}/>
      </Grid>
    </Grid>
  );
};

export default Inspections;
